export const theme = {
  dark: {
    // override for origin vuetify
    primary: '#00B6F0',

    alert: '#FFE86C',
    error: '#FF5084',
    success: '#00D4AA',

    primary900: '#002833',
    primary800: '#005166',
    primary700: '#1E3B97',
    primary600: '#0B96C2',
    primary500: '#00B6F0',
    primary400: '#00CAFF',
    primary300: '#66DFFF',
    primary200: '#99EAFF',
    primary100: '#CCF4FF',

    neutral900: '#070707',
    neutral800: '#131313',
    neutral700: '#232323',
    neutral600: '#353537',
    neutral500: '#434343',
    neutral400: '#757677',
    neutral300: '#A8A8A8',
    neutral200: '#DADADA',
    neutral100: '#ffffff',

    pink400: '#FF1A01',
    pink300: '#FF6996',
    pink200: '#FF65E6',
    pink100: '#121316',

    green300: '#00C773',
    green200: '#0CE4BE',
    green100: '#0FF4C6',

    list1: '#6388FF',
    list2: '#FF65E6',
    list3: '#22AFFF',

    ruler: '#BCFFE3',

    link: '#92ACFF',
    menu1: '#343434',
    menu2: '#424242',
    accent2: '#FF2E92',
    accent3: '#0DC773'
  }
};
